import { isNative } from '@/lib/platform';
import { commands } from '@/lib/platform/generated/bindings.gen';

type Theme = 'light' | 'dark' | 'system';

/**
 * Push the app theme to the native window so macOS vibrancy (frosted sidebar)
 * tints to match. Pass the RAW theme, NOT the resolved value: the native side
 * sets an explicit NSAppearance for 'light'/'dark' but CLEARS it for 'system'
 * so the window follows the OS. If we passed the resolved 'light'/'dark', the
 * window would stay pinned and `prefers-color-scheme` (read by getSystemTheme)
 * would keep reporting the pinned value — leaving 'system' stuck at whatever it
 * first resolved to. No-op on web. Fire-and-forget; failures are non-fatal.
 */
export async function pushWindowTheme(theme: Theme): Promise<void> {
  if (!isNative) return;
  const res = await commands.setWindowTheme(theme);
  // Explicit silent-swallow: vibrancy failures are non-fatal (the old
  // `.catch(() => {})` had the same intent). This is a deliberate choice.
  if (res.status === 'error') return;
}
